/**
 * Global Event Listeners
 *
 * @author Simple Digital
 */

